const MAX_HISTORY = 50;

const state = {
  undoStack: [],
  redoStack: []
};

const mutations = {
  ADD_TO_UNDO(state, feature) {
    state.undoStack.push(feature);
    if (state.undoStack.length > MAX_HISTORY) {
      state.undoStack.shift();
    }
  },
  POP_UNDO(state) {
    return state.undoStack.pop();
  },
  ADD_TO_REDO(state, feature) {
    state.redoStack.push(feature);
    if (state.redoStack.length > MAX_HISTORY) {
      state.redoStack.shift();
    }
  },
  POP_REDO(state) {
    return state.redoStack.pop();
  },
  CLEAR_REDO(state) {
    state.redoStack = [];
  },
  RESET_HISTORY(state) {
    state.undoStack = [];
    state.redoStack = [];
  }
};

const actions = {
  pushFeature({ commit }, feature) {
    commit('ADD_TO_UNDO', { type: 'add', feature });
    commit('CLEAR_REDO');
  },
  pushDeletion({ commit }, feature) {
    commit('ADD_TO_UNDO', { type: 'delete', feature });
    commit('CLEAR_REDO');
  },
  undo({ state, commit }) {
    if (state.undoStack.length === 0) return null;
    const action = state.undoStack[state.undoStack.length - 1];
    commit('ADD_TO_REDO', action);
    commit('POP_UNDO');
    return action;
  },
  redo({ state, commit }) {
    if (state.redoStack.length === 0) return null;
    const action = state.redoStack[state.redoStack.length - 1];
    commit('ADD_TO_UNDO', action);
    commit('POP_REDO');
    return action;
  },
  clearHistory({ commit }) {
    commit('RESET_HISTORY');
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
